import * as H from 'history';
import { parse } from 'query-string';
import { filterNamespacedUrlFilters } from './namespaceUrlFilters';

export const computeFiltersFromUrl = (
  location: H.Location | undefined,
  namespace: string | undefined,
) => {
  let resourceListFilters = {};
  if (location) {
    const params = parse(location.search);
    resourceListFilters = filterNamespacedUrlFilters(params, namespace);
  }

  return resourceListFilters;
};
